import { useEffect, useRef, useState } from 'react';

interface UseFadeInOnScrollOptions {
  threshold?: number;
  rootMargin?: string;
  triggerOnce?: boolean;
}

export const useFadeInOnScroll = (options: UseFadeInOnScrollOptions = {}) => {
  const { threshold = 0.1, rootMargin = '0px', triggerOnce = true } = options;
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Only trigger on scroll down (entry.isIntersecting) and if we haven't seen it before
        if (entry.isIntersecting && !hasBeenVisible) {
          setIsVisible(true);
          if (triggerOnce) {
            setHasBeenVisible(true);
          }
        } else if (!entry.isIntersecting && !triggerOnce) {
          // Only hide if we're not using triggerOnce
          setIsVisible(false);
        }
      },
      {
        threshold,
        rootMargin,
      }
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold, rootMargin, triggerOnce, hasBeenVisible]);

  return { ref, isVisible };
}; 